import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowsClockwise } from "@phosphor-icons/react";
import api from "../lib/api";
import LeadSourcesPanel from "./admin-leads/LeadSourcesPanel";
import EmbedWidgetPanel from "./admin-leads/EmbedWidgetPanel";
import RecommendationsPanel from "./admin-leads/RecommendationsPanel";
import BudgetAllocatorPanel from "./admin-leads/BudgetAllocatorPanel";
import LeadsStatsPanel from "./admin-leads/LeadsStatsPanel";
import LeadsTablePanel from "./admin-leads/LeadsTablePanel";
import EmailDomainsPanel from "./admin-leads/EmailDomainsPanel";

export default function AdminLeadsPage() {
  const [leads, setLeads] = useState([]);
  const [stats, setStats] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [l, s] = await Promise.all([
        api.get("/admin/leads").then((r) => r.data),
        api.get("/admin/leads/stats").then((r) => r.data),
      ]);
      setLeads(l);
      setStats(s);
    } catch (e) {
      if (e.response?.status === 403) toast.error("Only the demo-org admin can view leads.");
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="p-6 sm:p-8 max-w-6xl" data-testid="admin-leads-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-400">ADMIN / LEAD MAGNET</div>
          <h1 className="font-display text-4xl font-black tracking-tighter mt-1">Leads.</h1>
          <p className="text-sm text-zinc-500 mt-2">Captured from the public Cash Flow Health Check.</p>
        </div>
        <button onClick={refresh} className="text-xs font-mono text-zinc-500 hover:text-zinc-950 flex items-center gap-1" data-testid="admin-leads-refresh">
          <ArrowsClockwise size={12} /> REFRESH
        </button>
      </div>

      <LeadsStatsPanel stats={stats} />
      <LeadsTablePanel leads={leads} />
      <EmailDomainsPanel />
      <LeadSourcesPanel />
      <BudgetAllocatorPanel />
      <RecommendationsPanel />
      <EmbedWidgetPanel />
    </div>
  );
}
